// extracted by mini-css-extract-plugin
export default {"loadMoreWrapper":"IssueTimeline-module__loadMoreWrapper__H_hm5Cz"};